import { supabase } from './supabase';

export const createMatch = async (userId, matchData) => {
  // userId가 상태 동기화 지연 등으로 비어있는 경우 세션에서 복구
  let uid = userId;
  if (!uid) {
    const { data: { user } } = await supabase.auth.getUser();
    uid = user?.id || null;
  }
  if (!uid) {
    throw new Error('로그인 정보를 확인하지 못했습니다. 잠시 후 다시 시도해주세요.');
  }
  const { data, error } = await supabase
    .from('matches')
    .insert({
      user_id: uid,
      hobby: matchData.hobby,
      region: matchData.region,
      ratio: matchData.ratio,
      times: matchData.times,
      age_group: matchData.ageGroup,
      gender: matchData.gender,
      status: 'waiting'
    })
    .select();
  if (error) throw error;
  return data;
};

export const getMyMatches = async (userId) => {
  const { data, error } = await supabase
    .from('matches')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  if (error) console.error(error);
  return data;
};

export const cancelMatch = async (matchId) => {
  const { error } = await supabase
    .from('matches')
    .update({ status: 'cancelled' })
    .eq('id', matchId);
  if (error) console.error(error);
};

export const getChatMessages = async (matchId) => {
  const { data, error } = await supabase
    .from('chat_messages')
    .select('*')
    .eq('match_id', matchId)
    .order('created_at', { ascending: true });
  if (error) console.error(error);
  return data;
};

export const sendChatMessage = async (matchId, userId, userName, text) => {
  const { data, error } = await supabase
    .from('chat_messages')
    .insert({ match_id: matchId, user_id: userId, user_name: userName, text })
    .select();
  if (error) console.error(error);
  return data;
};

export const subscribeToChatMessages = (matchId, callback) => {
  return supabase
    .channel(`chat_${matchId}`)
    .on('postgres_changes', {
      event: 'INSERT', schema: 'public',
      table: 'chat_messages',
      filter: `match_id=eq.${matchId}`
    }, callback)
    .subscribe();
};

export const getClubs = async () => {
  const { data, error } = await supabase
    .from('matches')
    .select('*')
    .eq('status', 'waiting')
    .order('created_at', { ascending: false });
  if (error) console.error(error);
  return data;
};